/* unplugin-vue-components disabled */import { render } from "./UserLocation.vue?vue&type=template&id=69cd608c&scoped=true"
import script from "./UserLocation.vue?vue&type=script&lang=js"
export * from "./UserLocation.vue?vue&type=script&lang=js"

import "./UserLocation.vue?vue&type=style&index=0&id=69cd608c&scoped=true&lang=css"

import exportComponent from "/Users/rabbuse/Project/Vue/plp-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69cd608c"]])

export default __exports__